import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Badges } from '../models';

@Injectable({
  providedIn: 'root',
})
export class HomeSidebarService {
  private badges = new Subject<boolean>();

  private isActive = new Subject<boolean>();

  constructor() {}

  getStatus(): Observable<boolean> {
    return this.isActive.asObservable();
  }

  updateStatus(status: boolean) {
    this.isActive.next(status);
  }

  getBadges() {
    return this.badges.asObservable();
  }

  updateBadges(new_badges: boolean) {
    this.badges.next(new_badges);
  }
}
